<template>
  <div>
      

  </div>
</template>

<script>
import { getPageDetail } from "@/api/page";

export default {
  name: 'PageIndex',
  components: {

  },
  data() {
    return {
      loading: true,
      detail: {},
      alias: '',
    };
  },
  computed: {

  },
  created() {
    this.alias = this.$route.query.alias || 'register';
    this.getIndex();
  },
  methods: {
    getIndex() {
      getPageDetail({ alias: this.$route.query.alias }).then(res => {
        this.loading = false;
        this.detail = res.data;
      }).catch((err) => {

      });
    },
  }
};
</script>

<style lang="scss" scoped></style>
